import { PropsWithChildren } from 'react'

import { useCreation } from 'ahooks'

import { useCreationForm } from '@eastcoal/formily/hooks/useCreationForm'

import { useStoreImperative } from '../../../hooks/useStoreImperative'
import { GenericalRecord } from '../../../types/utilities'

import { RemoteTableStoreContext } from './contexts/StoreContext'
import { RemoteTableStoreProviderProps } from './interface'
import { createRemoteTableStore } from './store/createStore'
import { RemoteTableStoreUpdater } from './StoreUpdater'

export const RemoteTableStoreProvider = <
  T extends GenericalRecord,
  P extends GenericalRecord
>({
  ref,
  searchForm: externalSearchForm,

  /* -------------------------------------------------------------------------- */
  /*                         RemoteTableStoreUpdater Props                      */
  /* -------------------------------------------------------------------------- */
  containerRef,
  rowKey,
  children,
  ...restProps
}: PropsWithChildren<RemoteTableStoreProviderProps<T, P>>) => {
  const searchForm = useCreationForm({ form: externalSearchForm })

  const store = useCreation(
    () => createRemoteTableStore({ containerRef, rowKey, searchForm }),
    [searchForm, rowKey]
  )

  useStoreImperative(ref, store)

  return (
    <RemoteTableStoreContext value={store}>
      <RemoteTableStoreUpdater
        containerRef={containerRef}
        rowKey={rowKey}
        {...restProps}
      />
      {children}
    </RemoteTableStoreContext>
  )
}
